import React, { JSX } from 'react';

import { Search as SearchIcon } from '@videoblocks/react-icons';

export default function NavSearchButton(): JSX.Element {
    return (
        <button
            type="submit"
            className="unifiedNav-searchButton pl-5 pb-3 pt-3 border-0 items-center inline-flex"
            aria-label="Submit Search"
        >
            <SearchIcon className="w-4 h-4 fill-current" />
        </button>
    );
}
